import { routesName, useGetAdminGetAllGroupsList, useNavigation } from "core";
import React,{ memo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Detail } from "../../templates";

const GroupDetail = memo(() => {
  const {_navigateWithParams}=useNavigation()
  const { i18n } = useTranslation();
  const { id } = useParams();
  
  const { data,isFetching } = useGetAdminGetAllGroupsList({pageNumber:"1",pageSize:"1",groupId :id});
  
  return (
    <>
      <Detail
        isLoading={isFetching}
        title={i18n.t("groupDetail")}
        type={"group"}
        data={data?.data}
        onClick={() => {
          _navigateWithParams(routesName.EDITGROUP, {
            id: id,
          });
        }}
      />
    </>
  );
});
export { GroupDetail };

